import { render, staticRenderFns } from "./bg-upload.vue?vue&type=template&id=60114526&scoped=true&"
import script from "./bg-upload.vue?vue&type=script&lang=js&"
export * from "./bg-upload.vue?vue&type=script&lang=js&"
import style0 from "./bg-upload.vue?vue&type=style&index=0&id=60114526&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60114526",
  null
  
)

export default component.exports